import {
    ComponentActionTypeEnum, DailyTransactionTypeEnum,
    SearchTransactionRequestModel,
    ToastModel,
    TransactionDetailResponseModel, TransactionItemResponseModel, transactionPrintRequestModel,
    TransactionResponseModel, UploadedFileModel,
    ValidationErrorModel
} from "../../../../models";
import {create} from "zustand";
import {printTransactionInitialValue, searchListInitialValues} from "../initialValues/initialValues";

interface TransactionState {
    // State
    //data: TransactionDetailResponseModel | null;
    object: TransactionDetailResponseModel | null;
    refundObject: TransactionDetailResponseModel | null;
    transactionItemObject: TransactionItemResponseModel|null;
    responseObject: TransactionResponseModel | null;
    printObject:transactionPrintRequestModel|null;
    list: TransactionResponseModel[];
    uploadedFiles:UploadedFileModel[];
    validationErrors: ValidationErrorModel[];

    toastModel: ToastModel;
    searchRequest: SearchTransactionRequestModel;
    transactionType:DailyTransactionTypeEnum;
    guidKey:string;

    loading: boolean;
    showDeleteModal: boolean;
    showPaymentDetailsModel: boolean;
    showRefundItemModel: boolean;

    totalRows:number;
    resetKey:number;
    componentActionType:ComponentActionTypeEnum;
    refreshListTrigger: string;
    transactionActivePageKey:string;
    // Actions
    //setData: (data: TransactionDetailResponseModel) => void;
    setObject: (object: TransactionDetailResponseModel | null) => void;
    setRefundObject: (refundObject: TransactionDetailResponseModel | null) => void;
    setResponseObject: (object: TransactionResponseModel | null) => void;
    setTransactionItemObject: (object: TransactionItemResponseModel|null) => void;
    setPrintObject: (object:transactionPrintRequestModel|null) => void;
    setTransactionType:(transactionType:DailyTransactionTypeEnum)=> void;
    setGuidKey:(guidKey:string)=>void;
    setList: (list: TransactionResponseModel[]) => void; // <-- Make sure this exists
    setValidationErrors: (errors: ValidationErrorModel[]) => void;
    setUploadedFiles: (files:UploadedFileModel[]) => void;
    setToastModel: (toast: ToastModel) => void;
    setSearchRequest: (searchRequest: SearchTransactionRequestModel) => void;

    setLoading: (loading: boolean) => void;
    setShowDeleteModal: (show: boolean) => void;
    setShowPaymentDetailsModel: (show: boolean) => void;
    setShowRefundItemModel: (show: boolean) => void;
    setTotalRows: (totalRows:number) => void;
    setResetKey: (totalRows:number) => void;
    setRefreshListTrigger: (trigger: string) => void;
    setTransactionActivePageKey: (key: string) => void;
    setComponentActionType: (componentActionType:ComponentActionTypeEnum) => void;
    resetState: () => void;
}

export const useTransactionStore = create<TransactionState>((set) => ({
   // data: null,
    object: null,
    refundObject: null,
    responseObject: null,
    transactionItemObject:null,
    printObject:printTransactionInitialValue,
    list: [],
    validationErrors: [],
    uploadedFiles:[],

    toastModel: { show: false, variant: "success", body: "", header: "" },
    searchRequest: searchListInitialValues(null),
    transactionType:DailyTransactionTypeEnum.None,
    guidKey:"",
    loading: false,
    showDeleteModal: false,
    showPaymentDetailsModel: false,
    showRefundItemModel: false,

    totalRows:0,
    resetKey:0,
    refreshListTrigger:"",
    transactionActivePageKey:"",
    componentActionType:ComponentActionTypeEnum.Add,

   // setData: (data) => set({ data }),
    setObject: (object) => set({ object }),
    setRefundObject: (object) => set({ refundObject: object }),
    setTransactionItemObject: (object) => set({ transactionItemObject: object }),
    setResponseObject: (object) => set({ responseObject: object }),
    setPrintObject: (object) => set({ printObject: object }),
    setTransactionType:(transactionType)=>set({transactionType}),
    setGuidKey:(guidKey)=>set({guidKey:guidKey}),

    setList: (list) => set({ list }),
    setValidationErrors: (errors) => set({ validationErrors: errors }),
    setUploadedFiles: (files) => set({ uploadedFiles: files }),
    setToastModel: (toast) => set({ toastModel: toast }),
    setSearchRequest: (searchRequest) => set({ searchRequest: searchRequest }),

    setLoading: (loading) => set({ loading }),
    setRefreshListTrigger: (trigger: string) => set({ refreshListTrigger: trigger }),
    setTransactionActivePageKey: (key: string) => set({ transactionActivePageKey: key }),
    setShowDeleteModal: (show) => set({ showDeleteModal: show }),
    setShowRefundItemModel: (show) => set({ showRefundItemModel: show }),
    setShowPaymentDetailsModel:(show)=> set({ showPaymentDetailsModel: show }),
    setTotalRows: (totalRows) => set({ totalRows: totalRows }),
    setResetKey: (key) => set({ resetKey: key }),
    setComponentActionType: (componentActionType) => set({ componentActionType: componentActionType }),
    resetState: () =>
        set({
          //  data: null,
            object: null,
            refundObject: null,
            responseObject: null,
            transactionItemObject:null,
            printObject:printTransactionInitialValue,
            list: [],
            validationErrors: [],
            uploadedFiles:[],
            toastModel: { show: false, variant: "success", body: "", header: "" },
            searchRequest: searchListInitialValues(null),
            showDeleteModal: false,
            showPaymentDetailsModel: false,
            showRefundItemModel:false,
            transactionType:DailyTransactionTypeEnum.None,
            guidKey:"",
            totalRows:0,
            refreshListTrigger:"",
            transactionActivePageKey:"",
            componentActionType:ComponentActionTypeEnum.Add,
        }),
}));